import './content-tabs.scss';

class ContentTabs {
    constructor (element, options) {
        const settings = {
            initAttr: 'data-content-tabs',
            toggleAttr: 'toggle',
            handleAttr: 'handle',
            eventScroller: null
        };

        this.settings = Object.assign({}, settings, options);
        this.$contentTabs = element;
        this.$$contentTabsToggles = this.$contentTabs.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.toggleAttr + '"]');
        this.$$contentTabsHandles = this.$contentTabs.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.handleAttr + '"]');
    }

    initialize () {
        if (this.$$contentTabsToggles.length > 1) {
            this.initToggles();
            this.setTitleHeight();
        }
    }

    setTitleHeight () {
        for (let i = 0; i < this.$$contentTabsHandles.length; i++) {
            const $title = this.$$contentTabsHandles[i].querySelector('.content-tabs__title');

            if ($title.clientHeight > 20) {
                this.$contentTabs.classList.add('is--top');
            }
        }
    }

    initToggles () {
        const $activeToggle = this.$contentTabs.querySelector('[' + this.settings.initAttr + '="' + this.settings.toggleAttr + '"]:checked');

        if ($activeToggle) {
            this.setActiveTab($activeToggle.id);
        }

        for (let i = 0; i < this.$$contentTabsToggles.length; i++) {
            const $currentToggle = this.$$contentTabsToggles[i];

            $currentToggle.addEventListener('change', () => {
                if ($currentToggle.checked === true) {
                    const currentToggleId = $currentToggle.id;

                    this.setActiveTab(currentToggleId);
                }
            });
        }
    }

    setActiveTab (id) {
        const $activeHandle = this.$contentTabs.querySelector('[for="' + id + '"]');

        for (let i = 0; i < this.$$contentTabsHandles.length; i++) {
            const $currentHandle = this.$$contentTabsHandles[i];

            if ($currentHandle !== $activeHandle && $currentHandle.classList.contains('is--active')) {
                $currentHandle.classList.remove('is--active');
            }
        }

        $activeHandle.classList.add('is--active');

        const windowScrollEvent = new CustomEvent('scroll', {
            view: window,
            bubbles: true,
            cancelable: false
        });

        window.dispatchEvent(windowScrollEvent);
    }
}

export { ContentTabs };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$contentTabs = $context.querySelectorAll('[data-content-tabs="root"]');

        if ($$contentTabs.length > 0) {
            for (let i = 0; i < $$contentTabs.length; i++) {
                const $contentTabs = new ContentTabs($$contentTabs[i], {
                    eventScroller: window.eventScroller
                });
                $contentTabs.initialize();
            }
        }
    }
});
